import React, {Component} from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {FormattedMessage, FormattedNumber} from "react-intl";
import messages from "./messages";
import CartTile from "../components/CartTile";
import {Button} from "../../../components";
import {Legal, isEmpty} from "../../../utils";
import {CART_REVIEWED} from "../constants";

const Ul = styled.ul`
    && {
        padding: 0;
        margin: 0;
        overflow-y: auto;
        position: relative;
        z-index: 100;
        flex-grow: 1;
        height: 100px;
    }
`;
const Li = styled.li`
    list-style: none;
`;
const Footer = styled.footer`
    border-top: 1px solid lightgray;
    padding: 10px;
    margin-top: auto;
    position: relative;
    z-index: 200;
    background-color: white;
`;
const TextBox = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 700;
    margin-left: 10px;
    margin-right: 10px;
`;
const LegalContainer = styled.div`
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
`;
const Price = styled.span`
    &:after {
        content: "${(props) => (props.locale === "fr" ? "$" : "")}";
    }
    &:before {
        content: "${(props) => (props.locale === "en" ? "$" : "")}";
    }
`;
const StyledCartDetailWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    justify-content: flex-start;
    width: 100%;
`;

const CartDetailsComponent = ({cartItems, subTotal, handleClick, entitlement, locale}) => (
    <StyledCartDetailWrapper>
        {!!cartItems.length && (
            <Ul className="styled-scrollbars">
                {cartItems.map((cartItem) => (
                    <CartTile
                        key={cartItem.sku}
                        cartItem={cartItem}
                        locale={locale}
                        formattedPrice={<FormattedNumber value={cartItem.price} />}
                    />
                ))}
                {!isEmpty(entitlement) ? (
                    <CartTile
                        key={entitlement.sku}
                        cartItem={{
                            description: <FormattedMessage {...messages.entitlementDescription} />,
                            ...entitlement,
                        }}
                        type="entitlement"
                        locale={locale}
                        formattedPrice={<FormattedNumber value={entitlement.price} />}
                    />
                ) : null}
            </Ul>
        )}
        <Footer>
            <TextBox>
                <FormattedMessage {...messages.subtotal} />
                <Price locale={locale}>
                    <FormattedNumber value={subTotal} />
                </Price>
            </TextBox>
            <LegalContainer>
                {isEmpty(entitlement) ? (
                    <Legal>
                        <FormattedMessage {...messages.legal} />
                    </Legal>
                ) : null}
            </LegalContainer>
            <Button
                onClick={handleClick}
                text={
                    subTotal ? (
                        <FormattedMessage {...messages.cta} />
                    ) : (
                        <FormattedMessage {...messages.entitlementcta} />
                    )
                }
                classes="btn btn-filled-bby"
            />
        </Footer>
    </StyledCartDetailWrapper>
);
CartDetailsComponent.propTypes = {
    cartItems: PropTypes.array,
    orderDetails: PropTypes.object,
    entitlement: PropTypes.object,
    subTotal: PropTypes.number,
    handleClick: PropTypes.func,
    locale: PropTypes.string,
};

export default CartDetailsComponent;



// WEBPACK FOOTER //
// ./src/containers/Cart/CartDetails/CartDetailsComponent.js